<terra-dialog-header [showCloseButton]="false">
  <h1>Terms and Conditions Update</h1>
</terra-dialog-header>

<mat-dialog-content>
  <p>We're updating the following terms and conditions for your account.<br>
    Please read them carefully.</p>
  <ul class="terms-list">
    <li *ngFor="let term of data.termsToApprove">
      <a href="{{termType.getUrl(term)}}" target="_blank">{{termType.toString(term)}}</a>
    </li>
  </ul>
</mat-dialog-content>

<mat-checkbox color="primary" [checked]="approvedByUser$ | async" (change)="onChange($event)">
  I accept the new Terms and Conditions
</mat-checkbox>

<div mat-dialog-actions>
  <button mat-flat-button color="primary" [disabled]="!(approvedByUser$ | async)" (click)="approve()">
    Approve {{data.termsToApprove.length > 1 ? data.termsToApprove.length + ' terms' : ''}}
  </button>
</div>

